import { render, staticRenderFns } from "./RelatorioTipo.vue?vue&type=template&id=8a069e1e&"
import script from "./RelatorioTipo.vue?vue&type=script&lang=js&"
export * from "./RelatorioTipo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports